import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WRENCH_MODE_SCHEDULE_LOCATIONS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'WRENCH_MODE_SCHEDULE_LOCATIONS'
);
export const WRENCH_MODE_SCHEDULE_LOCATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WRENCH_MODE_SCHEDULE_LOCATIONS_CRUD_ACTION_CONSTANTS
);
